// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useEffect, useState } from 'react';
import { Chapter, LabModule, ModuleType, AssessmentModule, VodModule, HyperlinkModule, Progress, ChallengeModule, ExamModule, TextModule } from '../../types/Model';
import { S } from './styles';
import LabIcon from '../../assets/images/card-lab-icon.svg';
import ChallengeIcon from '../../assets/images/challenge-icon-in-card.svg';
import AssessmentIcon from '../../assets/images/card-assessment-icon.svg';
import VodIcon from '../../assets/images/card-vod-icon.svg';
import HyperlinkIcon from '../../assets/images/hyperlink-icon.svg';
import HyperlinkLinkIcon from '../../assets/images/hyperlink-link-icon.svg';
import TextIcon from '../../assets/images/text-icon.svg';
import DisabledTextIcon from '../../assets/images/disabled-text-icon.svg';
import DisabledLabIcon from '../../assets/images/disabled-lab-icon.svg';
import DisabledChallengeIcon from '../../assets/images/disabled-challenge-icon.svg';
import DisabledAssessmentIcon from '../../assets/images/disabled-quiz-icon.svg';
import DisabledVodIcon from '../../assets/images/disabled-vod-icon.svg';
import DisabledHyperlinkIcon from '../../assets/images/disabled-hyperlink-icon.svg';
import { parseDuration } from '../../lib/utility';
import CollapseTransition from '../CollapseTransition';
import { CompletionStatusType } from '../../types/Model';
import { InfoTextType } from '../NewCard/components/InfoText';
import { FormattedMessage } from 'react-intl';
/**
 * enum for decide the URL inside list
 */
export enum ContentsFromType {
  WORKSHOP = 'workshops',
  ONLINE_COURSE = 'onlineCourses',
  ILT_COURSE = 'iltCourses'
}

const renderVodContent = (id: number, chapterModule: VodModule, chapterIndex: number, chapterModuleIndex: number, contentsFrom: ContentsFromType, isOwned: boolean) => {
  return (
    <S.LinkWrap
      key={chapterModuleIndex}
      to={isOwned ? `/${contentsFrom}/${id}/contents?chapter=${chapterIndex + 1}&module=${chapterModuleIndex + 1}` : ''}
      as={isOwned ? S.LinkWrap : S.DisabledLinkWrap}
    >
      <S.ChapterContentDetail isOwned={isOwned}>
        <S.ModuleIcon src={isOwned ? VodIcon : DisabledVodIcon} />
        <S.ChapterModuleName>{chapterModule.name}</S.ChapterModuleName>
        <S.StateIcon>
          {chapterModule.status === 'Complete' && <S.CompletionStatusTag type={CompletionStatusType.COMPLETED} />}
        </S.StateIcon>
        <S.Duration>
          {parseDuration(chapterModule.duration || 0).auto}
        </S.Duration>
      </S.ChapterContentDetail>
    </S.LinkWrap>
  )
}

const renderLabContent = (id: number, chapterModule: LabModule, chapterIndex: number, chapterModuleIndex: number, contentsFrom: ContentsFromType, isOwned: boolean, handleUpdateProgress: (progress: Progress) => void) => {
  const fromWorkshop = contentsFrom === ContentsFromType.WORKSHOP ? `?workshopId=${id}` : ''
  const fromCourse = contentsFrom === ContentsFromType.ONLINE_COURSE ? `?courseId=${id}` : ''
  const fromIltCourse = contentsFrom === ContentsFromType.ILT_COURSE ? `?iltCourseId=${id}` : ''
  const labUrl = isOwned ? `/labs/${chapterModule.labId}${fromWorkshop}${fromCourse}${fromIltCourse}` : ''

  return (
    <S.LinkWrap
      key={chapterModuleIndex}
      to={labUrl}
      as={isOwned ? S.LinkWrap : S.DisabledLinkWrap}
      target="_blank"
      // onClick={() => isOwned ? handleUpdateProgress({ labId: chapterModule.labId }) : {} }
    >
      <S.ChapterContentDetail isOwned={isOwned}>
        <S.ModuleIcon src={isOwned ? LabIcon : DisabledLabIcon} />
        <S.ChapterModuleName>{chapterModule.name}</S.ChapterModuleName>
        <S.StateIcon>
          {chapterModule.status === 'Complete' && <S.CompletionStatusTag type={CompletionStatusType.COMPLETED} />}
        </S.StateIcon>
        <S.Duration>
          {parseDuration(chapterModule.duration || 0).auto}
        </S.Duration>
      </S.ChapterContentDetail>
    </S.LinkWrap>
  )
}

const renderChallengeContent = (id: number, chapterModule: ChallengeModule, chapterIndex: number, chapterModuleIndex: number, contentsFrom: ContentsFromType, isOwned: boolean, handleUpdateProgress: (progress: Progress) => void) => {
  const fromWorkshop = contentsFrom === ContentsFromType.WORKSHOP ? `?workshopId=${id}` : ''
  const fromCourse = contentsFrom === ContentsFromType.ONLINE_COURSE ? `?courseId=${id}` : ''
  const fromIltCourse = contentsFrom === ContentsFromType.ILT_COURSE ? `?iltCourseId=${id}` : ''
  const challengeUrl = isOwned ? `/challenges/${chapterModule.challengeId}${fromWorkshop}${fromCourse}${fromIltCourse}` : ''
  return (
    <S.LinkWrap
      key={chapterModuleIndex}
      to={challengeUrl}
      as={isOwned ? S.LinkWrap : S.DisabledLinkWrap}
      target="_blank"
      // onClick={() => isOwned ? handleUpdateProgress({ challengeId: chapterModule.challengeId }) : {} }
    >
      <S.ChapterContentDetail isOwned={isOwned}>
        <S.ModuleIcon src={isOwned ? ChallengeIcon : DisabledChallengeIcon} />
        <S.ChapterModuleName>{chapterModule.name}</S.ChapterModuleName>
        <S.StateIcon>
          {chapterModule.status === 'Complete' && <S.CompletionStatusTag type={CompletionStatusType.COMPLETED} />}
        </S.StateIcon>
        <S.Duration>
          {parseDuration(chapterModule.duration || 0).auto}
        </S.Duration>
      </S.ChapterContentDetail>
    </S.LinkWrap>
  )
}

const renderExamContent = (id: number, chapterModule: ExamModule, chapterIndex: number, chapterModuleIndex: number, contentsFrom: ContentsFromType, isOwned: boolean, handleUpdateProgress: (progress: Progress) => void) => {
  const fromWorkshop = contentsFrom === ContentsFromType.WORKSHOP ? `?workshopId=${id}` : ''
  const fromCourse = contentsFrom === ContentsFromType.ONLINE_COURSE ? `?courseId=${id}` : ''
  const fromIltCourse = contentsFrom === ContentsFromType.ILT_COURSE ? `?iltCourseId=${id}` : ''
  const examUrl = isOwned ? `/exams/${chapterModule.examId}${fromWorkshop}${fromCourse}${fromIltCourse}` : ''
  return (
    <S.LinkWrap
      key={chapterModuleIndex}
      to={examUrl}
      as={isOwned ? S.LinkWrap : S.DisabledLinkWrap}
      target="_blank"
      // onClick={() => isOwned ? handleUpdateProgress({ examId: chapterModule.examId }) : {} }
    >
      <S.ChapterContentDetail isOwned={isOwned}>
        <S.ModuleIcon src={isOwned ? AssessmentIcon : DisabledAssessmentIcon} />
        <S.ChapterModuleName>{chapterModule.name}</S.ChapterModuleName>
        <S.StateIcon>
          {chapterModule.status === 'Complete' && <S.CompletionStatusTag type={CompletionStatusType.COMPLETED} />}
        </S.StateIcon>
        <S.Duration>
          {parseDuration(chapterModule.duration || 0).auto}
        </S.Duration>
      </S.ChapterContentDetail>
    </S.LinkWrap>
  )
}
const renderAssessmentContent = (id: number, chapterModule: AssessmentModule, chapterIndex: number, chapterModuleIndex: number, contentsFrom: ContentsFromType, isOwned: boolean) => {
  return (
    <S.LinkWrap
      key={chapterModuleIndex}
      to={isOwned ? `/${contentsFrom}/${id}/contents?chapter=${chapterIndex + 1}&module=${chapterModuleIndex + 1}` : ''}
      as={isOwned ? S.LinkWrap : S.DisabledLinkWrap}
    >
      <S.ChapterContentDetail isOwned={isOwned}>
        <S.ModuleIcon src={isOwned ? AssessmentIcon : DisabledAssessmentIcon} />
        <S.ChapterModuleName>{chapterModule.name}</S.ChapterModuleName>
        <S.StateIcon>
          {chapterModule.status === 'Complete' && chapterModule.score !== undefined && <S.CompletionStatusTag type={CompletionStatusType.COMPLETED} score={chapterModule.score}/>}
        </S.StateIcon>
        <S.Duration>
        </S.Duration>
      </S.ChapterContentDetail>
    </S.LinkWrap>
  )
}

const renderHyperlinkContent = (id: number, chapterModule: HyperlinkModule, chapterIndex: number, chapterModuleIndex: number, contentsFrom: ContentsFromType, isOwned: boolean, handleUpdateProgress: (progress: Progress) => void) => {
  return (
    <S.HyperlinkWrap
      key={chapterModuleIndex}
      href={chapterModule.link}
      as={isOwned ? S.HyperlinkWrap : S.DisabledHyperlinkWrap}
      target="_blank"
      onClick={() => isOwned ? handleUpdateProgress({ hyperlinkId: chapterModule.hyperlinkId ? chapterModule.hyperlinkId : 'null' }) : {} }
    >
      <S.ChapterContentDetail isOwned={isOwned}>
        <S.ModuleIcon src={isOwned ? HyperlinkIcon : DisabledHyperlinkIcon} />
        <S.ChapterModuleName>{chapterModule.name}<S.ModuleIcon src={HyperlinkLinkIcon} style={{ marginLeft: '20px' }} /></S.ChapterModuleName>
        <S.StateIcon>
          {chapterModule.status === 'Complete' && <S.CompletionStatusTag type={CompletionStatusType.COMPLETED} />}
        </S.StateIcon>
        <S.Duration>
        </S.Duration>
      </S.ChapterContentDetail>
    </S.HyperlinkWrap>
  )
}

const renderTextContent = (chapterModule: TextModule, chapterModuleIndex: number, isOwned: boolean) => {
  return (
    <S.TextWrap
      key={chapterModuleIndex}
      as={isOwned ? S.TextWrap : S.DisabledTextWrap}
    >
      <S.ChapterContentDetail isOwned={isOwned}>
        <S.ModuleIcon src={isOwned ? TextIcon : DisabledTextIcon} />
        <S.TextChapterModuleName>{chapterModule.name}</S.TextChapterModuleName>
      </S.ChapterContentDetail>
    </S.TextWrap>
  )
}

/**
 * @param chapter - Chapter data
 * @param chapterIndex - index the chapter
 * @param id - id the online course or workshop
 * @param isOpen - state open or close the chapter detail
 * @param contentsFrom - to generate workshop or online course url
 * @returns - JSX Element
 */
const renderContentList = (chapter: Chapter, chapterIndex: number, id: number, isOpen: boolean, contentsFrom: ContentsFromType, isOwned: boolean, handleUpdateProgress: (progress: Progress) => void): JSX.Element => {
  return (
    <CollapseTransition visible={isOpen}>
      <S.ChapterContentList>
        {chapter.modules.map((chapterModule, chapterModuleIndex) => (
          chapterModule.type === ModuleType.VIDEO && renderVodContent(id, chapterModule, chapterIndex, chapterModuleIndex, contentsFrom, isOwned) ||
          chapterModule.type === ModuleType.LAB && renderLabContent(id, chapterModule, chapterIndex, chapterModuleIndex, contentsFrom, isOwned, handleUpdateProgress) ||
          chapterModule.type === ModuleType.CHALLENGE && renderChallengeContent(id, chapterModule, chapterIndex, chapterModuleIndex, contentsFrom, isOwned, handleUpdateProgress) ||
          chapterModule.type === ModuleType.EXAM && renderExamContent(id, chapterModule, chapterIndex, chapterModuleIndex, contentsFrom, isOwned, handleUpdateProgress) ||
          chapterModule.type === ModuleType.ASSESSMENT && renderAssessmentContent(id, chapterModule, chapterIndex, chapterModuleIndex, contentsFrom, isOwned) ||
          chapterModule.type === ModuleType.HYPERLINK && renderHyperlinkContent(id, chapterModule, chapterIndex, chapterModuleIndex, contentsFrom, isOwned, handleUpdateProgress) ||
          chapterModule.type === ModuleType.TEXT && renderTextContent(chapterModule, chapterModuleIndex, isOwned)
        ))}
      </S.ChapterContentList>
    </CollapseTransition >
  )
}

/**
 * @param props - { Chapters data, id of online course or workshop, contonet for online course or workshop}
 * @returns - JSX Element
 */
const Contents = (props: { chapters: Chapter[], id: number, contentsFrom: ContentsFromType, isOwned: boolean, handleUpdateProgress: (progress: Progress) => void; }): JSX.Element => {
  const { chapters, id, contentsFrom, isOwned, handleUpdateProgress } = props;

  function getChapterVisibles() {
    const allComplete = chapters.every(chapter => chapter.modules.every(module => 'status' in module && module.status === 'Complete'));
    const firstIncompleteChapter = chapters.find(chapter => chapter.modules.some(module => 'status' in module && module.status !== 'Complete'))

    return chapters.map((chapter) => {
      return !isOwned || // 1. 開始使用前：全部展開，方便觀看什麼內容
        firstIncompleteChapter === chapter || // 2. 開始使用中：展開未上過課程中相對簡單的那一章節
        allComplete // 3. 完成課程後：全部展開。
    })
  }

  const [chapterVisibles, setChapterVisibles] = useState<boolean[]>(getChapterVisibles());

  const toggleChapterVisible = (index: number) => {
    setChapterVisibles(chapterVisibles.map((value, i) => index === i ? !value : value));
  };

  useEffect(() => {
    setChapterVisibles(getChapterVisibles());
  }, [id, chapters, contentsFrom, isOwned])

  return (
    <div>
      {chapters.map((chapter, chapterIndex) => {
        const isVisible = chapterVisibles[chapterIndex];

        return (
          <S.Wrapper key={chapterIndex}>
            <S.ChapterHeader>
              <S.ChapterTitle>{chapter.name}</S.ChapterTitle>
              <S.ChapterTotalContents>
                {chapter.vodCount != 0 && (<S.InfoTotal type={InfoTextType.VOD}><FormattedMessage id="D015" /> {chapter.vodCount}</S.InfoTotal>)}
                {chapter.labCount != 0 && (<S.InfoTotal type={InfoTextType.LAB}><FormattedMessage id="D016" /> {chapter.labCount}</S.InfoTotal>)}
                {chapter.challengeCount != 0 && (<S.InfoTotal type={InfoTextType.CHALLENGE}><FormattedMessage id="D026" /> {chapter.challengeCount}</S.InfoTotal>)}
                {chapter.assessmentCount != 0 && (<S.InfoTotal type={InfoTextType.ASSESSMENT}><FormattedMessage id="D017" /> {chapter.assessmentCount}</S.InfoTotal>)}
                {chapter.examCount != 0 && (<S.InfoTotal type={InfoTextType.EXAM}><FormattedMessage id="D027" /> {chapter.examCount}</S.InfoTotal>)}
              </S.ChapterTotalContents>
              <S.TotalDuration>
                {parseDuration(chapter.totalDuration || 0).auto}
              </S.TotalDuration>
              <S.ToggleButton onClick={() => toggleChapterVisible(chapterIndex)} isOpen={isVisible} />
            </S.ChapterHeader>
            {renderContentList(chapter, chapterIndex, id, isVisible, contentsFrom, isOwned, handleUpdateProgress)}
          </S.Wrapper>
        )
      })}
      { chapters.length === 0 ? <S.NoDataText>No Chapters</S.NoDataText> : null }
    </div>
  )
}

export { Contents as default };
